import { EMAIL_COMPOSER_IDS } from '../consts';
import type { PublicationKind } from '@/features/comments/types/publication-kind';

type CommentFocusInput = {
  publicationKind: PublicationKind;
  chapterId?: string;
  articleId?: number;
  paragraphId?: string;
  isReply: boolean;
};

export function resolveCommentComposerId(input: CommentFocusInput): string | undefined {
  if (input.isReply || input.paragraphId) return undefined;
  if (input.publicationKind === 'review' && !input.chapterId) return EMAIL_COMPOSER_IDS.review;
  if (input.chapterId) return EMAIL_COMPOSER_IDS.chapterComment;
  if (input.articleId) return EMAIL_COMPOSER_IDS.articleComment;
  return EMAIL_COMPOSER_IDS.comment;
}
